import QrScanner from "qr-scanner";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Row,
} from "../../components/Component";
import { PreviewCard } from "../../components/preview/Preview";
import { useUser } from "../../context/user";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { decodeOutsourcingQr, USER_ROLES } from "../../utils/Utils";

// Tài xế và trưởng ca không dùng chức năng quét QR phiếu cân gia công
const BLOCKED_ROLES = [USER_ROLES.DRIVER, USER_ROLES.SHIFT_LEADER];

// Quét QR phiếu cân gia công (in từ trạm cân nhận gia công) để tạo đơn thuê gia công, điền sẵn thông tin.
// Tách riêng khỏi màn "Quét mã QR" (màn đó dùng cho chấm công / cập nhật đơn từ phiếu cân).
const ScanOutsourcingQR = ({ history }) => {
  const videoRef = useRef();
  const qrScannerRef = useRef();
  const shouldNotScan = useRef(false);
  const [cameraList, setCameraList] = useState([]);
  const [cameraChoosed, setCameraChoosed] = useState("environment");
  const {
    state: { user },
  } = useUser();
  const isBlocked = BLOCKED_ROLES.includes(user?.role);

  const actionScan = (text) => {
    shouldNotScan.current = true;
    let qr = null;
    try {
      qr = decodeOutsourcingQr(text);
    } catch (e) {
      qr = null;
    }
    if (!qr) {
      toast.error("Đây không phải QR phiếu cân gia công. Vui lòng thử lại sau 3s");
      setTimeout(() => {
        shouldNotScan.current = false;
      }, 3000);
      return;
    }
    history.push(`/bill/create?outsourcingQr=${encodeURIComponent(text)}`);
  };

  useEffect(() => {
    if (isBlocked || !videoRef.current) {
      return;
    }
    qrScannerRef.current = new QrScanner(
      videoRef.current,
      (result) => {
        if (result?.data && !shouldNotScan.current) {
          actionScan(result.data);
        }
      },
      {
        highlightScanRegion: true,
      }
    );
    qrScannerRef.current.start().then(() => {
      QrScanner.listCameras(true).then((cameras) => {
        setCameraList(cameras);
      });
    });
    return () => {
      qrScannerRef.current?.stop();
      qrScannerRef.current?.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBlocked]);

  if (isBlocked) {
    return (
      <React.Fragment>
        <Head title="Quét QR gia công"></Head>
        <Content>
          <Block size="lg">
            <PreviewCard>
              <p className="text-danger mb-0">Tài xế và trưởng ca không dùng chức năng quét QR phiếu cân gia công.</p>
            </PreviewCard>
          </Block>
        </Content>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Head title="Quét QR gia công"></Head>
      <Content>
        <Block size="lg">
          <BlockHead size="sm">
            <BlockBetween className="g-3">
              <BlockHeadContent>
                <BlockTitle page>
                  <strong className="small">Quét QR gia công</strong>
                </BlockTitle>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <PreviewCard>
            <Row className="gy-5">
              <Col lg="12">
                <p className="text-soft">
                  Quét QR trên phiếu cân gia công để tạo đơn thuê gia công (điền sẵn khách hàng, kho, nguyên liệu, khối lượng).
                </p>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <div className="w-100">
                    <select
                      className="form-control mb-2"
                      value={cameraChoosed}
                      onChange={(e) => {
                        setCameraChoosed(e.target.value);
                        qrScannerRef.current.setCamera(e.target.value);
                      }}
                    >
                      <option value="environment">Environment Facing (default)</option>
                      {cameraList.map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ maxWidth: 480 }}>
                    <video ref={videoRef} width={"100%"}></video>
                  </div>
                </div>
              </Col>
            </Row>
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ScanOutsourcingQR;
